import {createFileRoute, redirect} from '@tanstack/react-router';
import {USER_HOME} from '@/shared/routing/paths';

function RedirectToHome() {
  return null;
}

export const Route = createFileRoute('/(patient)/patient/payment-orders/$paymentOrderId/pay')({
  component: RedirectToHome,
  beforeLoad: function () {
    throw redirect({to: USER_HOME, replace: true});
  }
});
